
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"8","viewBox":"0 0 12 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.0187 0.3572C5.41833 -0.118674 6.15064 -0.118674 6.55027 0.3572L11.3328 6.05222C11.8792 6.70284 11.4167 7.69531 10.5671 7.69531L1.00191 7.69531C0.152295 7.69531 -0.310259 6.70284 0.236124 6.05222L5.0187 0.3572Z","fill":"#7D919B"}})])
          )
        }
      }
    